var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Success",
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.129,
    height: 97.129,
    viewBox: "0 0 97.129 97.129",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M48.564,0A48.564,48.564,0,1,0,97.129,48.564,48.621,48.621,0,0,0,48.564,0ZM75.707,35.784,44.669,66.578a4.775,4.775,0,0,1-6.694.122L21.544,51.729a4.936,4.936,0,0,1-.365-6.816,4.815,4.815,0,0,1,6.816-.243L41.018,56.6,68.769,28.847a4.906,4.906,0,0,1,6.938,6.938Z",
    fill: "#35c46d"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.cb1891090ffc335ad949c029ef4681a9.svg";